export default "__VITE_ASSET__87b90f1e__"